import { ReportNews } from "../types";
import axios from "../utils/axios";

export function getNewsPosts(token: string, orderBy: string, page: number) {
  return new Promise(function (resolve, reject) {
    axios
      .get(`/news?orderBy=${orderBy}&limit=${30}&page=${page}`, {
        headers: token
          ? {
              Authorization: `Bearer ${token}`,
            }
          : {},
      })
      .then((res) => {
        if (res.status === 200) {
          return resolve(res.data);
        } else {
          return reject(res.data.message);
        }
      })
      .catch((err) => reject(err));
  });
}

export function reportNewsPosts(token: string, body: ReportNews) {
  return new Promise(function (resolve, reject) {
    axios
      .post("/news/report", body, {
        headers: token
          ? {
              Authorization: `Bearer ${token}`,
            }
          : {},
      })
      .then((res) => {
        if (res.status === 200) {
          return resolve(res.data);
        } else {
          return reject(res.data.message);
        }
      })
      .catch((err) => reject(err));
  });
}
